const KEY = 'lumora.household'

export function rememberHousehold(id: string) {
  try {
    localStorage.setItem(KEY, id)
  } catch {
    /* ignore */
  }
}

export function recallHousehold(): string | null {
  try {
    return localStorage.getItem(KEY)
  } catch {
    return null
  }
}

export function forgetHousehold() {
  try {
    localStorage.removeItem(KEY)
  } catch {
    /* ignore */
  }
}
